import { render, staticRenderFns } from "./Collapse.vue?vue&type=template&id=3d4c39a8&scoped=true"
import script from "./Collapse.vue?vue&type=script&lang=js"
export * from "./Collapse.vue?vue&type=script&lang=js"
import style0 from "./Collapse.vue?vue&type=style&index=0&id=3d4c39a8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d4c39a8",
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/components/Collapse.vue
// module id = 1443
// module chunks = 31